import React from 'react';
import './Projects.css';
import { FaArrowRight } from 'react-icons/fa';

const Projects = () => {
  const projects = [
    {
      category: 'SaaS Company',
      title: 'Subscription Management',
      description: 'Kelola 5000+ recurring customers dengan automated billing cycle dan dunning management.',
      tags: ['Auto Billing', 'Subscription', 'Email Reminder']
    },
    {
      category: 'Agency',
      title: 'Project-based Invoicing',
      description: 'Invoice tracking untuk 100+ active projects dengan milestone billing dan time tracking integration.',
      tags: ['Project Invoice', 'Milestone', 'Time Tracking']
    },
    {
      category: 'E-commerce',
      title: 'B2B Order Management',
      description: 'Automated purchase order dan invoice generation untuk 200+ reseller dengan multi-tier pricing.',
      tags: ['PO Management', 'B2B', 'Multi-pricing']
    },
    {
      category: 'Consultant',
      title: 'Professional Services',
      description: 'Invoice management untuk consulting firm dengan hourly billing dan expense reimbursement.',
      tags: ['Hourly Rate', 'Expense', 'Client Portal']
    },
    {
      category: 'Distributor',
      title: 'Wholesale Distribution',
      description: 'Multi-currency invoicing untuk export-import business dengan 500+ customers worldwide.',
      tags: ['Multi-currency', 'Export', 'Tax Compliance']
    },
    {
      category: 'Education',
      title: 'Tuition & Fee Management',
      description: 'Student billing system dengan installment plan dan automatic late payment reminder.',
      tags: ['Installment', 'Auto Reminder', 'Parent Portal']
    }
  ];

  return (
    <section id="projects" className="projects">
      <div className="container">
        <div className="section-header">
          <span className="section-label">SUCCESS STORIES</span>
          <h2 className="section-title">Dipercaya oleh Berbagai Industri</h2>
          <p className="section-description">
            Lihat bagaimana Orion Billing membantu bisnis meningkatkan efisiensi dan cash flow
          </p>
        </div>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card">
              <div className="project-category">{project.category}</div>
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <div className="project-tags">
                {project.tags.map((tag, idx) => (
                  <span key={idx} className="tag">{tag}</span>
                ))}
              </div>
              <a href="#contact" className="project-link">
                Request Demo <FaArrowRight />
              </a>
            </div>
          ))}
        </div>

        <div className="projects-cta">
          <a href="#contact" className="btn-primary">Lihat Semua Proyek</a>
        </div>
      </div>
    </section>
  );
};

export default Projects;
